import { ca } from '@cian/analytics';
import { TView } from '@cian/feedback-form-widget';

export function trackViewShow(view: TView) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'FeedBackForm',
    action: 'Show',
    label: view,
  });
}
